import { KudosApiClient } from '@fourthwall/services/dist/KudosApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useSkipKudoMutation = createMutationHook(KudosApiClient.skipKudo, {
  mutationKey: ['skipKudo'],
})
